import React from "react";

export const reqText = () => {
  return `Zorunludur.`;
};
export const minText = (value: number): string => {
  return `En az ${value} karakter girmelisiniz.`;
};

export const maxText = (value: number): string => {
  return `En fazla ${value} karakter girebilirsiniz.`;
};

export const minNumberText = (value: number): string => {
  return `Girdiğiniz değer ${value} değerinden küçük olamaz..`;
};

export const maxNumberText = (value: number): string => {
  return `Girdiğiniz değer ${value} değerinden büyük olamaz.`;
};

export const onlyNumberText = () => {
  return `Sadece rakam girebilirsiniz.`;
};

export const compareDateText = (value: any, comparedValue: any): string => {
  return `${value} tarihi ${comparedValue} tarihinden küçük olamaz..`;
};

export const invalidEmailText = (): string => {
  return `Geçersiz email adresi.`;
};

export const passwordMatch = (): string => {
  return `  /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\\$%\\^&\\*])(?=.{8,})/,
        "Şifre en az 8 karakter olmalı. En az 1 büyük harf, 1 küçük harf, 1 rakam ve 1 özel karakter içermelidir.",`;
};

export const passwordFooter = (): React.ReactElement => {
  return (
    <>
      <p className="mt-2">Şifreniz,</p>
      <ul className="pl-2 ml-2 mt-0 line-height-3">
        <li>En az bir küçük harf</li>
        <li>En az bir büyük harf</li>
        <li>En az bir rakam</li>
        <li>En az bir özel karakter (“?, @, !, #, %, +, -, *, %” )</li>
        <li>En az 8 karakter olmalı</li>
      </ul>
    </>
  );
};

export const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  const aylar = [
    "Ocak",
    "Şubat",
    "Mart",
    "Nisan",
    "Mayıs",
    "Haziran",
    "Temmuz",
    "Ağustos",
    "Eylül",
    "Ekim",
    "Kasım",
    "Aralık",
  ];
  return `${aylar[date.getMonth()]} ${date.getFullYear()}`;
};
